import { CompanyServiceType } from "@vahak/core/dist/constants/serviceTypeId";
import { moEngageUserAttributeTrack, moEngageUserLogIn, moEngageUserPhoneNum } from "@vahak/core/dist/_services/user-analytics.service";
import { WebsiteUserType } from "@vahak/core/dist/_services/hooks/useEventTrackerService";
import { GA4EventNames, VWOEvents } from "@vahak/core/dist/constants/event-names";
import { COOKIES, DefaultCookieOptions } from "@vahak/core/dist/constants/misc";
import { GenericObject } from "@vahak/core-ui/dist/types/common";

import { LoginFormFieldsTypes } from "../../common/contant";
import { LoginFormAuthResult } from "../loginFormAuth.types";

export type LoginEventTracker = (name: string, data?: GenericObject) => void;

export function trackGetOtpClicked(handleEventTracking: LoginEventTracker, whatsappUpdatesEnabled: boolean) {
    handleEventTracking(GA4EventNames.LOGIN_OR_SIGNUP_MODAL["get_otp_clicked"]);
    moEngageUserAttributeTrack("moe_wa_subscription", String(whatsappUpdatesEnabled));
}

export function trackOtpSubmitted(handleEventTracking: LoginEventTracker) {
    handleEventTracking(GA4EventNames.LOGIN_OR_SIGNUP_MODAL["otp_submit"]);
}

export function trackRegisteredUserLogin(handleEventTracking: LoginEventTracker, status: LoginFormAuthResult) {
    handleEventTracking(GA4EventNames.LOGIN_OR_SIGNUP_MODAL["user_login"], {
        login_via: "manual",
        company_id: status.companyId,
        user_id: status.userId
    });
}

export function trackNewUserSignupStarted(
    handleEventTracking: LoginEventTracker,
    status: LoginFormAuthResult,
    phoneNum?: string | number
) {
    handleEventTracking(GA4EventNames.LOGIN_OR_SIGNUP_MODAL["user_signup"], {
        sign_up_via: "manual",
        company_id: status.companyId,
        user_id: status.userId
    });
    moEngageUserLogIn(Number(status.userId));
    moEngageUserAttributeTrack("user_signedup", new Date().toISOString());
    moEngageUserAttributeTrack("user_type", WebsiteUserType.CLIENT);
    phoneNum && moEngageUserPhoneNum(phoneNum);
}

export function trackCompanyRegistration(
    handleEventTracking: LoginEventTracker,
    values: LoginFormFieldsTypes,
    result: LoginFormAuthResult
) {
    const payload = {
        source_screen: "company_registration",
        services: values.serviceType,
        company_name: values.companyName,
        referral_code: values.referralCode,
        company_id: result?.companyId,
        user_id: result?.userId
    };

    handleEventTracking(GA4EventNames.COMPANY_REGISTRATION["company_details_submitted"], payload);
    handleEventTracking(GA4EventNames.COMPANY_REGISTRATION["user_registered"], payload);
}

export function applyLoginSuccessSideEffects({
    status,
    globalData,
    setGlobalData
}: {
    status: LoginFormAuthResult;
    globalData?: Record<string, unknown>;
    setGlobalData?: (data: Record<string, unknown>) => void;
}) {
    moEngageUserLogIn(Number(status.userId));
    moEngageUserAttributeTrack("company_name", status.companyName!);
    moEngageUserAttributeTrack("user_type", WebsiteUserType.CLIENT);
    window?.VWO?.event(VWOEvents.login_success);
    setGlobalData?.({
        ...globalData,
        is_login_successful: true
    });
}

export function applyRegistrationSuccessSideEffects({
    values,
    setCookie
}: {
    values: LoginFormFieldsTypes;
    setCookie: (name: string, value: string, options: object) => void;
}) {
    if (values.serviceType === CompanyServiceType.FLEET_OWNER) {
        sessionStorage.setItem("mandatePostingTrucker", "true");
    }

    setCookie(COOKIES.newUser, JSON.stringify("true"), {
        ...DefaultCookieOptions,
        expires: new Date(Date.now() + 5 * 60 * 1000),
        maxAge: 60
    });

    moEngageUserAttributeTrack("company_name", values.companyName);
    moEngageUserAttributeTrack("wa_number", String(values.phoneNumber).replace(/^\+91/, ""));
    moEngageUserAttributeTrack("user_registered", new Date().toISOString());
    window?.VWO?.event(VWOEvents.sign_up_success);
}
